import { useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useVCESToken } from "@companion-core/shared/app/Queries";
import { useRegisterStore } from "@companion-core/shared/app/Store/registerStore";
import { getModule } from "@companion-core/shared/app/Utils/config";

export const useVCESiframe = () => {
  const { i18n, t } = useTranslation();
  const { data, isFetching, refetch } = useVCESToken();
  const registerModule = getModule("register");
  const { setRegisterContent, setCorrelationId } = useRegisterStore((state) => ({
    setRegisterContent: state.setRegisterContent,
    setCorrelationId: state.setCorrelationId,
  }));
  const correlationId = useMemo(() => data?.data?.result?.correlation_id ?? null, [data]);
  const vcesIframeLink = useMemo(() => registerModule?.vces?.iframeLink ?? "", [registerModule]);
  const completeVCESUrl = useMemo(
    () =>
      vcesIframeLink.replace("{token}", data?.data?.result?.token).replace("{lang}", i18n.language),
    [vcesIframeLink, data],
  );

  useEffect(() => {
    refetch();
  }, [i18n.language]);

  useEffect(() => {
    setCorrelationId(correlationId);
  }, [correlationId]);

  return {
    t,
    isFetching,
    completeVCESUrl,
    setRegisterContent,
  };
};
